export class ListOfPlanItemResponse {
	id: number;
	plan_date: string;
	plan_id: number;
	begin_time: string;
	end_time: string;
}
